export enum TableNames {
    EventTrackings = 'eventTrackings',
  }